import React, { FC } from 'react';
import { ScrollView, View } from 'react-native';
import {
  IMAGES_PANEL_VIEW_MODE_WIDTH,
  NOT_PANEL_VIEW_MODE_WIDTH,
  PANEL_VIEW_MODE_WIDTH,
  SCREEN_PADDING_HORIZONTAL,
  SCREEN_PADDING_HORIZONTAL_FOR_ITEM,
} from '../../../../../../common/constants/base.constants';
import { fullWidth, scale as initialScale } from '@components/frame';
import { JobContent } from './JobContent';
import { isPhone, isWeb } from '@helpers';
import ImagesContainer, { ImagesContainerMode } from '@v2/pages/common/components/ImagesContainer/ImagesContainer';
import { OperationSearchItem } from '@interfaces/search';
import { DOCUMENT_ENTITY_TYPE } from '@components/imageHandling/common';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { font as initialFont } from '@styles/fonts';
import { useManageSingleJobOrList } from '@v2/pages/machines/modules/now/components/Job/hooks/useManageSingleJobOrList';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

export interface SingleJobOrListProps {
  jobs: (OperationSearchItem | null)[];
  jobId: number | null;
  loading: boolean;
  shouldTakeFromBatch?: boolean;
  jobDataLoadingForList?: boolean;
  displaySingleJob?: boolean;
  displayImagesColumn?: boolean;
  ignoreHeaderConfig?: boolean;
  maxDetailsWidth?: number;
  scale?: ScaleFunction;
  font?: typeof initialFont;
}

const SingleJobOrList: FC<SingleJobOrListProps> = ({
  jobs,
  jobId,
  loading,
  shouldTakeFromBatch,
  jobDataLoadingForList,
  displaySingleJob,
  maxDetailsWidth: defaultMaxDetailsWidth,
  displayImagesColumn = true,
  ignoreHeaderConfig = false,
  scale = initialScale,
  font = initialFont,
}) => {
  const {
    existedJobs,
    shouldDisplaySingleJob,
    isDetailsScreen,
    isMachinesScreen,
    shouldDisplayImagesColumn,
    containerStyles,
    onJobImageClick,
  } = useManageSingleJobOrList({ jobs, jobId, displaySingleJob, displayImagesColumn });

  return (
    <View
      style={{
        flexDirection: 'row',
        maxWidth: scale(isMachinesScreen ? NOT_PANEL_VIEW_MODE_WIDTH : shouldDisplaySingleJob ? PANEL_VIEW_MODE_WIDTH : fullWidth),
        marginInline: 'auto',
        width: '100%',
        flex: 1,
      }}
    >
      <ScrollView
        contentContainerStyle={[
          containerStyles,
          isMachinesScreen && { paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL - SCREEN_PADDING_HORIZONTAL_FOR_ITEM), paddingTop: 0 },
        ]}
        showsVerticalScrollIndicator={false}
      >
        <JobContent
          jobs={existedJobs}
          loading={loading}
          displaySingleJob={displaySingleJob}
          jobDataLoadingForList={jobDataLoadingForList}
          maxDetailsWidth={
            defaultMaxDetailsWidth
              ? defaultMaxDetailsWidth
              : shouldDisplaySingleJob
              ? PANEL_VIEW_MODE_WIDTH - IMAGES_PANEL_VIEW_MODE_WIDTH
              : fullWidth
          }
          withImages={isPhone || (shouldDisplaySingleJob && (isMachinesScreen || !isDetailsScreen))}
          shouldTakeFromBatch={shouldTakeFromBatch}
          currentJobId={jobId}
          ignoreHeaderConfig={ignoreHeaderConfig}
          bg={!isWeb ? 'Background/Light/Field on Panel' : 'Background/Light/Field'}
          scale={scale}
          font={font}
        />
      </ScrollView>
      {!loading && shouldDisplayImagesColumn && (
        <View testID={TEST_IDS.jobContent.sideImagesContainer} style={{ paddingTop: scale(SCREEN_PADDING_HORIZONTAL_FOR_ITEM) }}>
          <ImagesContainer
            panelViewMode
            mode={ImagesContainerMode.COLUMN}
            documentRetrieveKey={DOCUMENT_ENTITY_TYPE.ProductionOperation}
            documentRetrieveId={jobId}
            onImagePress={onJobImageClick}
            scale={scale}
            font={font}
          />
        </View>
      )}
    </View>
  );
};

export { SingleJobOrList };
